import { baseApi } from 'api/baseApi';
import {
  BatchExportParameters,
  ReuseBatchExportParameters,
} from 'types/exportObjects.type';
import { invalidateTagsByResponseId } from '../../JobResults/utils/jobUtil';

export const exportObjectsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    startExportJob: build.mutation<{ id: string }, BatchExportParameters>({
      query: (params) => ({
        url: '/objects/batch-operations/jobs/batch-export',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: invalidateTagsByResponseId,
    }),
    reuseExportJob: build.mutation<{ id: string }, ReuseBatchExportParameters>({
      query: ({ jobId, ...body }) => ({
        url: `/objects/batch-operations/jobs/batch-export/${jobId}/reuse`,
        method: 'POST',
        body,
      }),
      invalidatesTags: invalidateTagsByResponseId,
    }),
    exportJobDownloadURL: build.query<{ url: string }, { id: string }>({
      query: ({ id }) => ({
        url: `/objects/batch-operations/jobs/batch-export/${id}/download`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useStartExportJobMutation,
  useReuseExportJobMutation,
  useLazyExportJobDownloadURLQuery,
} = exportObjectsApi;
